module.exports = __webpack_public_path__ + "media/images/smart_phone/sp_menu_reserving-1b1934b051ff8f4206da1e759cb4ec2b.png";